// import React from 'react';
import styled from 'styled-components';
import RaisedButton from 'material-ui/RaisedButton';


/*

Props:

• minWidth
• marginLeft
• marginRight

*/

export const StyledRaisedButton = styled(RaisedButton)`
flex: 0 0 auto;
min-width: ${props => (props.minMidth) ? props.minMidth+'px;' : '130px;'}
margin-left: ${props => (props.marginLeft) ? props.marginLeft+'px;' : '0px;'}
margin-right: ${props => (props.marginRight) ? props.marginRight+'px;' : '0px;'}

`;



// WEBPACK FOOTER //
// ./src/js/components/StyledRaisedButton.jsx